<template>
  <span
    class="learning-area-pointer"
    :style="`--learning-area-color: ${color}`"
  >
    {{ name }}
  </span>
</template>

<script>
export default {
  name: 'LearningAreaPointer',
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.learning-area-pointer {
  display: flex;
  align-items: center;
  &::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--learning-area-color);
    margin-right: 5px;
  }
}
</style>
